import styled from 'styled-components';
import { WCS } from './week-utils';

export const CalendarWeekSC = styled.div<{ mode: 'view' | 'edit' }>`
  position: relative;

  * {
    user-select: none;
  }

  .empty {
    width: 100%;
    height: 60px;
  }

  .calendar-content-wrapper {
    position: relative;
    height: calc(100vh - ${WCS.stickyAreaHeight}px);
    overflow: scroll;
    z-index: 5;
    padding-bottom: ${({ mode }) => (mode === 'view' ? 480 : 500)}px;
  }

  .calendar-content {
    margin: 0 ${WCS.timeLineWidth}px;
    height: 100%;
    display: flex;
    z-index: 1;
    position: relative;
  }

  .content-wrapper {
    position: relative;
    overflow-y: auto;
    transition: filter 0.4s;

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`;
